import React from 'react';

export const GoogleMetricsOverlay = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none select-none" aria-hidden="true">
      {/* Google Ads Dashboard Recreation - only on large screens */}
      <div className="absolute top-[4%] left-[1%] w-[56%] h-[90%] opacity-[0.12] hidden lg:block">
        <div className="w-full h-full rounded-xl bg-[hsl(222_30%_14%_/_0.4)] p-4 border border-[hsl(222_20%_22%_/_0.3)]">

          {/* Top bar - mimics Google Ads nav */}
          <div className="flex items-center gap-3 mb-4 pb-3 border-b border-[hsl(222_20%_22%_/_0.3)]">
            <div className="flex gap-1">
              <div className="w-3 h-3 rounded-full" style={{ background: 'hsl(217 89% 61%)' }} />
              <div className="w-3 h-3 rounded-full" style={{ background: 'hsl(24 90% 55%)' }} />
              <div className="w-3 h-3 rounded-full" style={{ background: 'hsl(185 72% 38%)' }} />
            </div>
            <div className="text-[hsl(220_15%_95%)] text-[10px] font-medium">Overview</div>
            <div className="text-[hsl(222_15%_55%)] text-[10px]">Campaigns</div>
            <div className="text-[hsl(222_15%_55%)] text-[10px]">Ad groups</div>
            <div className="text-[hsl(222_15%_55%)] text-[10px]">Keywords</div>
          </div>

          {/* Google Ads colored metric cards row */}
          <div className="grid grid-cols-4 gap-2 mb-4">
            {/* Clicks - Blue */}
            <div className="rounded-lg p-2.5" style={{ background: 'hsl(217 89% 61% / 0.15)', borderLeft: '3px solid hsl(217 89% 61%)' }}>
              <div className="text-[hsl(222_15%_55%)] text-[8px] uppercase tracking-wider mb-1">Clicks</div>
              <div className="text-[9px] font-bold" style={{ color: 'hsl(217 89% 61%)' }}>12.4K</div>
            </div>
            {/* Impressions - Teal */}
            <div className="rounded-lg p-2.5" style={{ background: 'hsl(185 72% 38% / 0.15)', borderLeft: '3px solid hsl(185 72% 38%)' }}>
              <div className="text-[hsl(222_15%_55%)] text-[8px] uppercase tracking-wider mb-1">Impr.</div>
              <div className="text-[9px] font-bold" style={{ color: 'hsl(185 72% 38%)' }}>248K</div>
            </div>
            {/* Cost - Orange */}
            <div className="rounded-lg p-2.5" style={{ background: 'hsl(24 90% 55% / 0.15)', borderLeft: '3px solid hsl(24 90% 55%)' }}>
              <div className="text-[hsl(222_15%_55%)] text-[8px] uppercase tracking-wider mb-1">Cost</div>
              <div className="text-[9px] font-bold" style={{ color: 'hsl(24 90% 55%)' }}>$18.2K</div>
            </div>
            {/* Conversions - Coral/Red */}
            <div className="rounded-lg p-2.5" style={{ background: 'hsl(0 72% 56% / 0.12)', borderLeft: '3px solid hsl(0 72% 56%)' }}>
              <div className="text-[hsl(222_15%_55%)] text-[8px] uppercase tracking-wider mb-1">Conv.</div>
              <div className="text-[9px] font-bold" style={{ color: 'hsl(0 72% 56%)' }}>847</div>
            </div>
          </div>

          {/* Second row of metrics */}
          <div className="grid grid-cols-3 gap-2 mb-4">
            <div className="rounded-lg p-2 border border-[hsl(222_20%_22%_/_0.3)]">
              <div className="text-[hsl(222_15%_55%)] text-[8px]">CTR</div>
              <div className="text-[hsl(220_15%_95%)] text-[10px] font-bold">5.01%</div>
            </div>
            <div className="rounded-lg p-2 border border-[hsl(222_20%_22%_/_0.3)]">
              <div className="text-[hsl(222_15%_55%)] text-[8px]">Avg. CPC</div>
              <div className="text-[hsl(220_15%_95%)] text-[10px] font-bold">$1.47</div>
            </div>
            <div className="rounded-lg p-2 border border-[hsl(222_20%_22%_/_0.3)]">
              <div className="text-[hsl(222_15%_55%)] text-[8px]">Cost / Conv.</div>
              <div className="text-[hsl(220_15%_95%)] text-[10px] font-bold">$21.50</div>
            </div>
          </div>

          {/* Multi-line chart */}
          <div className="rounded-lg p-3 border border-[hsl(222_20%_22%_/_0.3)] mb-3">
            <div className="flex gap-4 mb-2">
              <div className="flex items-center gap-1">
                <div className="w-2 h-0.5 rounded-full" style={{ background: 'hsl(217 89% 61%)' }} />
                <span className="text-[7px] text-[hsl(222_15%_55%)]">Clicks</span>
              </div>
              <div className="flex items-center gap-1">
                <div className="w-2 h-0.5 rounded-full" style={{ background: 'hsl(24 90% 55%)' }} />
                <span className="text-[7px] text-[hsl(222_15%_55%)]">Cost</span>
              </div>
              <div className="flex items-center gap-1">
                <div className="w-2 h-0.5 rounded-full" style={{ background: 'hsl(185 72% 38%)' }} />
                <span className="text-[7px] text-[hsl(222_15%_55%)]">Conv.</span>
              </div>
            </div>
            <svg className="w-full h-16" viewBox="0 0 400 64" preserveAspectRatio="none">
              {/* Clicks line - blue */}
              <polyline points="0,55 40,48 80,35 120,40 160,28 200,32 240,18 280,22 320,14 360,10 400,16" fill="none" stroke="hsl(217 89% 61%)" strokeWidth="1.5" />
              {/* Cost line - orange */}
              <polyline points="0,58 40,52 80,45 120,48 160,38 200,42 240,30 280,34 320,26 360,22 400,28" fill="none" stroke="hsl(24 90% 55%)" strokeWidth="1.5" />
              {/* Conversions line - teal */}
              <polyline points="0,50 40,52 80,42 120,38 160,35 200,28 240,25 280,20 320,18 360,15 400,12" fill="none" stroke="hsl(185 72% 38%)" strokeWidth="1.5" />
            </svg>
          </div>

          {/* Campaign table rows simulation */}
          <div className="space-y-1.5">
            <div className="flex items-center gap-2 text-[8px]">
              <div className="w-1.5 h-1.5 rounded-full" style={{ background: 'hsl(185 72% 38%)' }} />
              <div className="flex-1 h-1.5 bg-[hsl(222_15%_55%_/_0.15)] rounded-full" />
              <span className="text-[hsl(217_89%_61%)]" style={{ fontSize: '7px' }}>4,210</span>
              <span className="text-[hsl(24_90%_55%)]" style={{ fontSize: '7px' }}>$5.2K</span>
              <span style={{ color: 'hsl(0 72% 56%)', fontSize: '7px' }}>312</span>
            </div>
            <div className="flex items-center gap-2 text-[8px]">
              <div className="w-1.5 h-1.5 rounded-full" style={{ background: 'hsl(24 90% 55%)' }} />
              <div className="flex-1 h-1.5 bg-[hsl(222_15%_55%_/_0.12)] rounded-full" />
              <span className="text-[hsl(217_89%_61%)]" style={{ fontSize: '7px' }}>3,890</span>
              <span className="text-[hsl(24_90%_55%)]" style={{ fontSize: '7px' }}>$4.8K</span>
              <span style={{ color: 'hsl(0 72% 56%)', fontSize: '7px' }}>285</span>
            </div>
            <div className="flex items-center gap-2 text-[8px]">
              <div className="w-1.5 h-1.5 rounded-full" style={{ background: 'hsl(217 89% 61%)' }} />
              <div className="flex-1 h-1.5 bg-[hsl(222_15%_55%_/_0.10)] rounded-full" />
              <span className="text-[hsl(217_89%_61%)]" style={{ fontSize: '7px' }}>2,150</span>
              <span className="text-[hsl(24_90%_55%)]" style={{ fontSize: '7px' }}>$3.1K</span>
              <span style={{ color: 'hsl(0 72% 56%)', fontSize: '7px' }}>178</span>
            </div>
          </div>
        </div>
      </div>

      {/* Floating standalone metric cards */}
      <div className="absolute top-[10%] right-[40%] opacity-[0.08] hidden lg:block">
        <div className="rounded-lg p-2 border border-[hsl(222_20%_22%_/_0.3)] bg-[hsl(222_30%_14%_/_0.4)]">
          <div className="text-[hsl(222_15%_55%)] text-[8px]">ROAS</div>
          <div className="font-bold text-sm" style={{ color: 'hsl(185 72% 38%)' }}>4.2x</div>
        </div>
      </div>

      <div className="absolute bottom-[20%] left-[56%] opacity-[0.06] hidden lg:block">
        <div className="rounded-lg p-2 border border-[hsl(222_20%_22%_/_0.3)] bg-[hsl(222_30%_14%_/_0.4)]">
          <div className="text-[hsl(222_15%_55%)] text-[8px]">Conv. Rate</div>
          <div className="font-bold text-sm" style={{ color: 'hsl(24 90% 55%)' }}>6.82%</div>
        </div>
      </div>
    </div>
  );
};
